import { tKey } from 'ember-intl';

export const ACCESS_RIGHTS = {
  ADMIN: 'admin',
  WRITE: 'write',
  READ: 'read',
} as const;
export type AccessRight = (typeof ACCESS_RIGHTS)[keyof typeof ACCESS_RIGHTS];

export const MIXED = 'MIXED' as const;
export type MixedRole = typeof MIXED;

export const ROLE_OPTIONS_MAP: Record<AccessRight, ReturnType<typeof tKey>> = {
  admin: tKey('settings.users.role.admin'),
  write: tKey('settings.users.role.editor'),
  read: tKey('settings.users.role.viewer'),
};

export const PRODUCTS = {
  RATE_INSIGHT: 'rate_insight',
  BI_BENCHMARKING: 'revenue_insight',
} as const;
